import { VaultType } from '@sc1/common';

export function getVaultPath(
  vaultAddress: string,
  vaultTypeSlug: 'hlp' | 'scy' | undefined,
  tab: string = ''
) {
  if (!vaultTypeSlug) return '';
  return `/vaults/${vaultTypeSlug}/${vaultAddress}/${tab}`;
}
export function vaultTypeToSlug(vaultType: VaultType | undefined) {
  if (vaultType === VaultType.ScionVault) return 'hlp';
  if (vaultType === VaultType.SCYVault) return 'scy';
}
